import { render, staticRenderFns } from "./TransferLoanTransaction.vue?vue&type=template&id=2664b61e"
import script from "./TransferLoanTransaction.vue?vue&type=script&lang=js"
export * from "./TransferLoanTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports